(function (app, ng) {

    app.directive("scrollToId", ["$location", "$anchorScroll", function ($location, $anchorScroll) {
        return {
            link: function (scope, element, attr) {                  
                $(element).on("click", function () {
                    $location.hash(attr.scrollToId);
                    $anchorScroll();
                });
            }
        }
    }]);

})(window.app, window.angular); //jshint ignore:line